import { useEffect, useState } from "react";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestArticles from "@/pages/home/components/LatestArticles";
import PopularSection from "@/pages/home/components/PopularSection";
import {
  getFeaturedArticles,
  getLatestArticles,
  getPopularArticles,
} from "@/utils/articles";
import { articles } from "@/mocks/articles";

function IntroBand() {
  const stats = [
    { value: `${articles.length}+`, label: "收录文章" },
    { value: "3", label: "内容栏目" },
    { value: "2016", label: "创立年份" },
  ];
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className="text-xs tracking-[0.3em] text-secondary-600 mb-3">OUR EDITORIAL</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug mb-5">
            电影不只有故事，<br className="hidden md:block" />更是一套值得推敲的语言
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
            理论电影是一个专注影视理论与电影评论的内容平台。我们以杂志式的编排呈现深度文章，从蒙太奇与长镜头，到镜头背后的文化与产业，帮助读者在观看之外，再获得一种理解电影的方式。
          </p>
        </div>
        <div className="lg:col-span-5 grid grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="text-center bg-background-100 rounded-lg py-6">
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-700">
                {s.value}
              </p>
              <p className="text-xs text-foreground-500 mt-2">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function HomeSkeleton() {
  return (
    <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[0, 1, 2].map((i) => (
          <div key={i} className="rounded-lg border border-background-200 overflow-hidden">
            <div className="w-full aspect-[8/5] bg-background-100 animate-pulse" />
            <div className="p-5 space-y-3">
              <div className="h-3 w-20 bg-background-100 rounded animate-pulse" />
              <div className="h-4 w-full bg-background-100 rounded animate-pulse" />
              <div className="h-3 w-2/3 bg-background-100 rounded animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 450);
    return () => clearTimeout(t);
  }, []);

  const featured = getFeaturedArticles(3);
  const latest = getLatestArticles(10);
  const popular = getPopularArticles(4);

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />
      <IntroBand />
      <CategoryEntries />
      {loading ? (
        <HomeSkeleton />
      ) : articles.length === 0 ? (
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-24 text-center">
          <i className="ri-inbox-line text-5xl text-foreground-300" />
          <p className="mt-4 text-foreground-500">暂无内容，敬请期待</p>
        </div>
      ) : (
        <>
          <LatestArticles items={latest} />
          <PopularSection items={popular} />
        </>
      )}
    </SiteLayout>
  );
}